// WPM monogram — bold typographic mark with overlapping multicolor letters.
// Each letter uses mix-blend-mode: multiply so the kerned overlaps mix into
// rich brand-blended tones (must sit on a light background, hence the
// white pill wrapper used by the parent in Header & Footer).
export default function WPMLogo({ size = 36, className = "" }) {
  return (
    <span
      className={`inline-flex items-baseline font-display font-extrabold leading-none select-none ${className}`}
      style={{
        fontSize: size,
        letterSpacing: "-0.06em",
        fontFamily: '"Bricolage Grotesque", system-ui, sans-serif',
      }}
      aria-label="Web Print Media"
    >
      <span style={{ color: "#DC2626", mixBlendMode: "multiply" }}>W</span>
      <span
        style={{
          color: "#0EA5E9",
          mixBlendMode: "multiply",
          marginLeft: "-0.18em",
        }}
      >
        P
      </span>
      <span
        style={{
          color: "#CA8A04",
          mixBlendMode: "multiply",
          marginLeft: "-0.14em",
        }}
      >
        M
      </span>
    </span>
  );
}
